import appLogo from "../../../assets/images/app_logo.png";
import clockPlaceholder from "../../../assets/images/clock_placeholder.png";
import authBgImage from "../../../assets/images/auth_bg_image.png";
import authBgImage2 from "../../../assets/images/auth_bg_image_2.png";
import { ReactNode } from "react";
import moment from "moment";

interface AuthLayoutProps {
  children: ReactNode;
}

const footer = {
  version: `${__APP_VERSION__} - ${import.meta.env.VITE_ENV}`,
  build: __APP_BUILD_TIME__,
};

const AuthLayout = ({ children }: AuthLayoutProps) => {
  return (
    <div className="flex flex-col md:flex-row min-h-screen overflow-hidden relative">
      {/* Left side with logo and illustration - now visible on all screens */}
      <div
        className="flex-1 p-4 md:p-8 flex flex-col relative"
        style={{
          background:
            "linear-gradient(199.27deg, rgba(136, 198, 211, 0.4) 37.88%, #88C6D3 100%)",
        }}
      >
        <img
          src={authBgImage}
          alt="background_1"
          className="absolute w-[50%] md:w-[638px] h-auto md:h-[553px] -top-[30%] md:-top-[411px] -left-[5%] md:-left-[20px]"
        />

        {/* Logo and illustration on Medium and larger screens */}
        <div className="hidden md:flex flex-1 flex-col items-center justify-center">
          <img
            src={appLogo}
            alt="HLJ Creative"
            className="w-[328px] h-[83px] mb-4"
          />
          <img
            src={clockPlaceholder}
            alt="Time tracking illustration"
            className="w-[398px] h-[368px] z-10"
          />
        </div>

        {/* Logo and illustration on mobiles & tablets */}
        <div className="md:hidden sm:flex flex-1 flex flex-col items-center justify-center">
          {/* Logo on all screens */}
          <div className="flex items-center justify-center h-[60px] md:h-auto mb-4">
            <img
              src={appLogo}
              alt="HLJ Creative"
              className="h-[40px] md:h-[83px] w-auto"
            />
          </div>

          {/* Illustration container */}
          <div className="flex-1 flex flex-col items-center justify-center">
            <img
              src={clockPlaceholder}
              alt="Time tracking illustration"
              className="w-[70%] md:w-[398px] h-auto md:h-[368px] z-10"
            />
          </div>
        </div>

        <img
          src={authBgImage2}
          alt="background_2"
          className="absolute w-[70%] md:w-[638px] h-auto md:h-[583px] -bottom-[15%] md:-bottom-[200px] -left-[15%] md:-left-[208px] overflow-hidden"
        />

        {/* Version and build timestamp */}
        <div className="absolute bottom-2 flex gap-2 left-4 text-[10px] text-[#4A6572] opacity-70 z-20">
          <div>Version: {footer.version}</div>
          <div>Build: {moment(footer.build).format("DD-MM-YYYY HH:mm")}</div>
        </div>
      </div>

      {/* Right side with form */}
      <div className="flex-1 flex items-center justify-center p-4 md:p-8 bg-white">
        <div className="w-full max-w-[400px]">{children}</div>
      </div>
    </div>
  );
};

export default AuthLayout;
